import {ECO_ERROR_COUNT_KEY, EconomicsError} from 'smag-commons/dto/eco/errors';
import {EconomicsErrorType} from 'smag-commons/dto/eco';

export const MISSING_DATA_TH = 24;
export const MISSING_DATA_PERCENT_TH = 0.05;
export const MISSING_ZONAL_PRICE_TH = 0.1;

export function hasError(err: EconomicsErrorType, errors: EconomicsError[], additionalErrors?: EconomicsError[]): boolean {
    if (additionalErrors) {
        errors = [...errors, ...additionalErrors];
    }
    return errors ? !!errors.find(e => e.type === err) : false;
}

export function showError(err: EconomicsErrorType, errors: EconomicsError[], additionalErrors?: EconomicsError[]): boolean {
    if (additionalErrors) {
        errors = [...errors, ...additionalErrors];
    }

    if (err === EconomicsErrorType.DATA_FALLBACK && errors) { // show data fallback error only if hours > hours threshold
        return !!errors.find(e => e.type === err && e.metadata[ECO_ERROR_COUNT_KEY] > MISSING_DATA_TH);
    }

    if (err === EconomicsErrorType.MISSING_DATA && errors && this.billingPeriod) { // show missing data error only if hours > % hours threshold
        // if we also have a data fallback error, do not show missing data
        return !errors.find(e => e.type === EconomicsErrorType.DATA_FALLBACK) &&
            !!errors.find(e => e.type === err && e.metadata[ECO_ERROR_COUNT_KEY] /
                ((this.billingPeriod.toTime - this.billingPeriod.fromTime) / 3600000) > MISSING_DATA_PERCENT_TH);
    }

    if (err === EconomicsErrorType.MISSING_ZONAL_PRICE && errors && this.billingPeriod) { // show missing zonal price error only if hours > % hours threshold
        return !!errors.find(e => e.type === err && e.metadata[ECO_ERROR_COUNT_KEY] /
            ((this.billingPeriod.toTime - this.billingPeriod.fromTime) / 3600000) > MISSING_ZONAL_PRICE_TH);
    }
}

